

export default new class FormAskForCallMobile {
    constructor() {
        /* selectors */
        this.btnAskForCallMobSelector = '.btn-call';
        this.btnClearFromMobSelector = '.clear-form ';
        this.formDisplayedMobSelector = '.mobile-menu__form-ask-for-call';
        this.modalOpenedMobSelector = '.modal_opened';
        this.btnModalCloseMobSelector = '.button-modal-close';

        /* css classes */
        this.clearFormMobClass = 'clear-form';

    }

    init() {

        this.bindEvents();
    }

    bindEvents() {
        let $btnCloseModal = $(this.modalOpenedMobSelector).find(this.btnModalCloseMobSelector);
        let $form = $(this.formDisplayedMobSelector);

        $(document)
            .on('click', this.btnAskForCallMobSelector, (e) => {
                $($form).show();
                $($btnCloseModal).addClass(this.clearFormMobClass);

            })
            .on('click', this.btnClearFromMobSelector, (e) => {
                e.preventDefault();
                $($form).hide();
                $($btnCloseModal).removeClass(this.clearFormMobClass);
            })
            .keyup((e) => {
                if(e.keyCode === 27) {
                    $($form).hide();
                    $($btnCloseModal).removeClass(this.clearFormMobClass);
                }
            });
    }

};


// WEBPACK FOOTER //
// ./src/common/modules/mobile-menu/mobile-menu.js